import { FLOATING_COMPOUND_TABLE_STATES, APP_PERIOD_DROPDOWN_ELEMENTS, GROUP_BY_TAB_ELEMENTS, PERIOD_OPTIONS, TARGETING_TYPE_SPLIT, PERIOD_OPTIONS_V2, PPC_EXTRA_FILTERS, FILTER_KEYS } from "../utils/constants";
import moment from "moment";
import { request } from "@/store";
import Filter from "./filter";
import { computeDetailsForKpis, computeCurrencyMaxCharCount, computeNumberMaxCharCount, computePercentageMaxCharCount } from "@/utils/transformers";
import { computeMinMax, transformWithCountries } from "@/utils";
import { DATE_PICKER_RANGE_TITLES } from "@/utils/datepicker";
const DEFAULT_EMPTY_ROW_SIZE = 20;
import { Currencies } from "@/utils/currencies";
import { COMPONENTS, DEFAULT_SCOPES, Kpi, createCurrentPeriodViewFromData } from '@/utils/dashboard/current_period';
const ADS_TABS = {
  PERFORMANCE: {
    text: "Performance",
    value: "performance",
    activeBg: "var(--market-50)",
    activeColor: "var(--market-800)",
    icon: "StrokedPercentIcon",
    event: "advertisingPerformanceTabOpened"
  },
  STRATEGIC: {
    text: "Strategic",
    value: "strategic",
    activeBg: "var(--market-50)",
    activeColor: "var(--market-800)",
    icon: "StrokedStarIcon",
    event: "advertisingStrategicTabOpened"
  },
  BID_BUDGET_SETTINGS: {
    text: "Bid & Budget Settings",
    value: "settings",
    activeBg: "#F4F4F4",
    disabledActiveBg: "#FAFAFA",
    activeColor: "#4D4D4D",
    disabledActiveColor: "#757575",
    icon: "SettingsIcon",
    event: "advertisingSettingsTabOpened"
  }
};
export default {
  state: {
    sellers_filter: new Filter([], [], "id"),
    marketplaces_filter: new Filter([], [], "sales_channel"),
    product_groups: new Filter([], [], "campaign_group_name"),
    products: new Filter([], [], "products"),
    brands: new Filter([], [], "brands"),
    campaigns: new Filter([], [], "campaign_id", undefined, undefined, undefined, false),
    portfolios: new Filter([], [], "portfolio_name", undefined, undefined, undefined, false),
    ad_formats: new Filter([], [], "ad_format", undefined, undefined, undefined, false),
    targetings: new Filter([], [], "targeting", undefined, undefined, undefined, false),
    match_types: new Filter([], [], "match_type", undefined, undefined, undefined, false),
    targeting_types: new Filter(TARGETING_TYPE_SPLIT, [], "key", undefined, undefined, undefined, false),
    campaign_groups: new Filter([], [], "id", undefined, undefined, undefined, false),
    currencies: new Filter(Currencies, [], "symbol"),
    filterManager: null,
    ppcExtraFiltersToFilterKeysMap: {
      [PPC_EXTRA_FILTERS.AD_FORMAT]: FILTER_KEYS.AD_FORMATS,
      [PPC_EXTRA_FILTERS.PORTFOLIO]: FILTER_KEYS.PORTFOLIOS,
      [PPC_EXTRA_FILTERS.TARGETING]: FILTER_KEYS.TARGETINGS,
      [PPC_EXTRA_FILTERS.MATCH_TYPE]: FILTER_KEYS.MATCH_TYPES,
      [PPC_EXTRA_FILTERS.CAMPAIGN]: FILTER_KEYS.CAMPAIGNS,
      [PPC_EXTRA_FILTERS.CAMPAIGN_GROUP]: FILTER_KEYS.CAMPAIGN_GROUPS
    },
    currentTab: 0,
    currentTabValue: "performance",
    strategicTabIsDisabled: false,
    tabs: [ADS_TABS.PERFORMANCE, ADS_TABS.STRATEGIC, ADS_TABS.BID_BUDGET_SETTINGS],
    kpis: {
      data: {
        [PERIOD_OPTIONS.PREV_PERIOD]: [],
        [PERIOD_OPTIONS.SAME_PERIOD_LY]: []
      },
      CONSIDERED_KPIS: {
        [PERIOD_OPTIONS.PREV_PERIOD.value]: [{
          key: "sponsored_sales",
          name: "sponsored sales",
          subtitle: {
            name: "units sold",
            key: "units_sold_clicks_14_d"
          }
        }, {
          key: "spend",
          name: "spend",
          subtitle: {
            name: "clicks",
            key: "clicks"
          }
        }, {
          key: "TACOS",
          name: "TACOS",
          subtitle: {
            name: "ROAS",
            key: "ROAS"
          }
        }, {
          key: "CVR",
          name: "CVR",
          subtitle: {
            name: "CPC",
            key: "CPC"
          }
        }],
        [PERIOD_OPTIONS.SAME_PERIOD_LY.value]: [{
          key: "last_year_sponsored_sales",
          name: "sponsored sales",
          subtitle: {
            name: "units sold",
            key: "last_year_units_sold_clicks_14_d"
          }
        }, {
          key: "last_year_spend",
          name: "spend",
          subtitle: {
            name: "clicks",
            key: "last_year_clicks"
          }
        }, {
          key: "last_year_TACOS",
          name: "TACOS",
          subtitle: {
            name: "ROAS",
            key: "last_year_ROAS"
          }
        }, {
          key: "last_year_CVR",
          name: "CVR",
          subtitle: {
            name: "CPC",
            key: "last_year_CPC"
          }
        }]
      }
    },
    kpis_v2: {
      considered_kpis: {
        performance: new Kpi("sponsored_sales", "Sponsored Sales", DEFAULT_SCOPES(), COMPONENTS.CURRENCY),
        strategic: new Kpi("sponsored_sales", "Sponsored Sales", DEFAULT_SCOPES(), COMPONENTS.CURRENCY)
      }
    },
    period: APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY.value,
    periodSelectorOptions: [APP_PERIOD_DROPDOWN_ELEMENTS.DAILY, APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY, APP_PERIOD_DROPDOWN_ELEMENTS.MONTHLY, APP_PERIOD_DROPDOWN_ELEMENTS.QUARTERLY, APP_PERIOD_DROPDOWN_ELEMENTS.YEARLY],
    periodOptions: [PERIOD_OPTIONS.PREV_PERIOD, PERIOD_OPTIONS.SAME_PERIOD_LY],
    periodCategory: PERIOD_OPTIONS.PREV_PERIOD.queryKey,
    currentPeriod: {
      [APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY.value]: {
        title: "Week-to-date vs Same period Last Week",
        format: "MMM D, YYYY",
        date: moment().startOf("isoWeek"),
        groupBy: DATE_PICKER_RANGE_TITLES.CURRENT_WEEK,
        groupByCompare: {
          title: "Preceding Period",
          subtitle: "(match to date)"
        }
      },
      [APP_PERIOD_DROPDOWN_ELEMENTS.DAILY.value]: {
        title: "Yesterday vs Same day Last Week",
        format: "MMM DD, YYYY",
        date: moment().subtract(1, "days"),
        groupBy: DATE_PICKER_RANGE_TITLES.YESTERDAY,
        groupByCompare: {
          title: "Preceding Period",
          subtitle: "(match to date)"
        }
      },
      [APP_PERIOD_DROPDOWN_ELEMENTS.MONTHLY.value]: {
        title: "Month-to-date vs Same period Last Month",
        format: "MMM YYYY",
        date: moment().startOf("month"),
        groupBy: DATE_PICKER_RANGE_TITLES.CURRENT_MONTH,
        groupByCompare: {
          title: "Preceding Period",
          subtitle: "(match to date)"
        }
      },
      [APP_PERIOD_DROPDOWN_ELEMENTS.YEARLY.value]: {
        title: "Current year vs previous year",
        format: "YYYY",
        date: moment().startOf("year"),
        groupBy: DATE_PICKER_RANGE_TITLES.CURRENT_YEAR,
        groupByCompare: {
          title: 'Preceding Period',
          subtitle: '(match to date)'
        }
      },
      [APP_PERIOD_DROPDOWN_ELEMENTS.QUARTERLY.value]: {
        title: "Current quarter vs previous quarter",
        format: "MMM YYYY",
        date: moment().startOf("quarter"),
        groupBy: DATE_PICKER_RANGE_TITLES.CURRENT_QUARTER,
        groupByCompare: {
          title: 'Preceding Period',
          subtitle: '(match to date)'
        }
      }
    },
    periodTable: {
      period_page: 1,
      strategic: {
        items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
        maxCharCount: {},
        minMax: {},
        title: {
          [APP_PERIOD_DROPDOWN_ELEMENTS.DAILY.value]: "Last 14 days",
          [APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY.value]: "Last 12 weeks",
          [APP_PERIOD_DROPDOWN_ELEMENTS.MONTHLY.value]: "Last 12 months",
          [APP_PERIOD_DROPDOWN_ELEMENTS.QUARTERLY.value]: "Last 12 quarters"
        }
      },
      performance: {
        items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
        maxCharCount: {},
        minMax: {},
        title: {
          [APP_PERIOD_DROPDOWN_ELEMENTS.DAILY.value]: "Last 14 days",
          [APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY.value]: "Last 12 weeks",
          [APP_PERIOD_DROPDOWN_ELEMENTS.MONTHLY.value]: "Last 12 months",
          [APP_PERIOD_DROPDOWN_ELEMENTS.QUARTERLY.value]: "Last 12 quarters"
        }
      },
      errorOccurred: false
    },
    product_table: {
      state: FLOATING_COMPOUND_TABLE_STATES.CLOSED,
      group_by: 0,
      group_by_text: "",
      group_by_elements: [],
      disabled_group_by_elements: [],
      errorOccurred: false,
      strategic: {
        period: null,
        data: {
          seller: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              sponsored_sales: "desc",
              spend: "desc"
            },
            fetch: "ppcV2FetchReportGroupedBySellers"
          },
          marketplace: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              sponsored_sales: "desc",
              spend: "desc"
            },
            fetch: "ppcV2FetchReportGroupedByMarketplaces"
          },
          product: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            maxCharCount: {},
            minMax: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              sponsored_sales: "desc",
              spend: "desc"
            },
            fetch: "ppcV2FetchReportGroupedByProducts"
          },
          campaign_group: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            maxCharCount: {},
            minMax: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              sponsored_sales: "desc",
              spend: "desc"
            },
            fetch: "ppcV2FetchReportGroupedByCampaignGroups"
          },
          campaign: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            maxCharCount: {},
            minMax: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              sponsored_sales: "desc",
              spend: "desc"
            },
            fetch: "ppcV2FetchReportGroupedByCampaigns"
          },
          targeting: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            maxCharCount: {},
            minMax: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              sponsored_sales: "desc",
              spend: "desc"
            },
            fetch: "ppcV2FetchReportGroupedByTargetings"
          },
          ad_format: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            maxCharCount: {},
            minMax: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              sponsored_sales: "desc",
              spend: "desc"
            },
            fetch: "ppcV2FetchReportGroupedByAdFormats"
          }
        }
      },
      performance: {
        period: null,
        data: {
          seller: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              sponsored_sales: "desc",
              spend: "desc"
            },
            fetch: "ppcV2FetchReportGroupedBySellers"
          },
          marketplace: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              sponsored_sales: "desc",
              spend: "desc"
            },
            fetch: "ppcV2FetchReportGroupedByMarketplaces"
          },
          product: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            maxCharCount: {},
            minMax: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              sponsored_sales: "desc",
              spend: "desc"
            },
            fetch: "ppcV2FetchReportGroupedByProducts"
          },
          campaign_group: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            maxCharCount: {},
            minMax: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              sponsored_sales: "desc",
              spend: "desc"
            },
            fetch: "ppcV2FetchReportGroupedByCampaignGroups"
          },
          campaign: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            maxCharCount: {},
            minMax: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              sponsored_sales: "desc",
              spend: "desc"
            },
            fetch: "ppcV2FetchReportGroupedByCampaigns"
          },
          targeting: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            maxCharCount: {},
            minMax: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              sponsored_sales: "desc",
              spend: "desc"
            },
            fetch: "ppcV2FetchReportGroupedByTargetings"
          },
          ad_format: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            maxCharCount: {},
            minMax: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              sponsored_sales: "desc",
              spend: "desc"
            },
            fetch: "ppcV2FetchReportGroupedByAdFormats"
          }
        }
      }
    },
    renderedFilterNames: new Set()
  },
  mutations: {
    ppcSellersFilterSet(state, payload) {
      state.sellers_filter.restore(payload);
    },
    ppcMarketplacesFilterSet(state, payload) {
      state.marketplaces_filter.restore(payload);
    },
    ppcV2SetTab(state, payload) {
      state.currentTab = payload;
      state.currentTabValue = state.tabs[payload].value;
    },
    ppcV2SetPeriod(state, payload) {
      state.period = payload;
    },
    ppcV2SetPeriodTableItems(state, payload) {
      state.periodTable["strategic"].items = payload;
      state.periodTable["performance"].items = payload;
    },
    ppcV2DeselectPeriodTable(state) {
      state.tabs.forEach(({
        value
      }) => {
        (state.periodTable[value]?.items ?? []).forEach(item => {
          item.selected = undefined;
        });
      });
    },
    ppcV2SetPeriodTableMaxCharCount(state, payload) {
      state.periodTable["strategic"].maxCharCount = payload;
      state.periodTable["performance"].maxCharCount = payload;
    },
    ppcV2SetPeriodTableMinMax(state, payload) {
      state.periodTable["strategic"].minMax = payload;
      state.periodTable["performance"].minMax = payload;
    },
    ppcV2SetKpisData(state, {
      payload,
      category
    }) {
      state.kpis.data[category] = payload;
    },
    ppcV2SetProductTableGroupByElements(state, payload) {
      state.product_table.group_by_elements = payload;
    },
    ppcV2SetProductTableState(state, payload) {
      state.product_table.state = payload;
    },
    ppcV2SetProductTablePeriod(state, payload) {
      state.product_table["strategic"].period = payload;
      state.product_table["performance"].period = payload;
    },
    ppcV2SetProductTableItems(state, payload) {
      state.product_table["strategic"].data[state.product_table.group_by_text].items = payload;
      state.product_table["performance"].data[state.product_table.group_by_text].items = payload;
    },
    ppcV2SetProductTableGroupBy(state, payload) {
      state.product_table.group_by = payload;
      state.product_table.group_by_text = state.product_table.group_by_elements[payload].key;
    },
    ppcV2SetProductTableSort(state, {
      sort,
      direction
    }) {
      state.product_table["strategic"].data[state.product_table.group_by_text].sort = {
        [sort]: direction
      };
      state.product_table["performance"].data[state.product_table.group_by_text].sort = {
        [sort]: direction
      };
    },
    ppcV2SetProductTableMaxCharCount(state, payload) {
      state.product_table["strategic"].data[state.product_table.group_by_text].maxCharCount = payload;
      state.product_table["performance"].data[state.product_table.group_by_text].maxCharCount = payload;
    },
    ppcV2SetProductTableMinMax(state, payload) {
      state.product_table["strategic"].data[state.product_table.group_by_text].minMax = payload;
      state.product_table["performance"].data[state.product_table.group_by_text].minMax = payload;
    },
    ppcV2SetProductTableTotal(state, payload) {
      state.product_table["strategic"].data[state.product_table.group_by_text].total = payload;
      state.product_table["performance"].data[state.product_table.group_by_text].total = payload;
    },
    ppcV2SetProductTableTotalPages(state, payload) {
      state.product_table["strategic"].data[state.product_table.group_by_text].totalPages = payload;
      state.product_table["performance"].data[state.product_table.group_by_text].totalPages = payload;
    },
    ppcV2SetProductTablePage(state, payload) {
      state.product_table["strategic"].data[state.product_table.group_by_text].page = payload;
      state.product_table["performance"].data[state.product_table.group_by_text].page = payload;
    },
    ppcV2SetProductTablePerPage(state, payload) {
      state.product_table["strategic"].data[state.product_table.group_by_text].perPage = payload;
      state.product_table["performance"].data[state.product_table.group_by_text].perPage = payload;
    },
    ppcV2SetPeriodTableErrorState(state, payload) {
      state.periodTable.errorOccurred = payload;
    },
    ppcV2SetProductTableErrorState(state, payload) {
      state.product_table.errorOccurred = payload;
    },
    ppcV2DefaultCurrencySet(state, payload) {
      // We need to update the currency filter
      state.currencies.selectOnly({
        symbol: payload
      }, 'symbol');
      state.currencies.apply();
    },
    ppcV2DeactivateGroupBy(state, payload) {
      state.product_table.disabled_group_by_elements = payload;
    },
    ppcV2CleanDisabledGroupBy(state) {
      state.product_table.disabled_group_by_elements = [];
    },
    ppcV2SetPeriodCategory(state, payload) {
      state.periodCategory = payload;
    },
    ppcV2IncrementPeriodPage(state) {
      state.periodTable.period_page += 1;
    },
    ppcV2SetFilterManager(state, payload) {
      state.filterManager = payload;
    },
    ppcV2AddFilter(state, payload) {
      state.renderedFilterNames.add(payload);
    }
  },
  getters: {
    ppcV2GetPeriod(state) {
      return () => state.period;
    },
    ppcV2GetFilters(state) {
      return () => {
        return {
          seller_id: state.sellers_filter.filterValues,
          sales_channel: state.marketplaces_filter.filterValues,
          campaigns_list: state.campaigns.selectedValues,
          keyword_id_list: state.targetings.selected.flatMap(({
            keyword_id_list
          }) => keyword_id_list),
          match_type_list: state.match_types.selectedValues,
          sku_list: state.products.selected.map(product => product.sku).filter(Boolean),
          asin_list: state.products.selected.map(product => product.asin).filter(Boolean),
          ad_format_list: state.ad_formats.selectedValues,
          portfolio_id_list: state.portfolios.selected.flatMap(({
            portfolio_id_list
          }) => portfolio_id_list),
          targeting_types_list: state.targeting_types.selectedValues,
          campaign_group_list: state.campaign_groups.selectedValues,
          brand_list: state.brands.selected.map(({
            brand_list
          }) => brand_list).filter(Boolean).flat()
        };
      };
    },
    ppcV2UnifiedFilters(_, getters) {
      return () => {
        const allFilters = getters.ppcV2GetFilters();
        const secondaryEnabledFilters = {
          ...allFilters,
          sku_list: [],
          asin_list: []
        };
        return getters.ppcV2SecondaryFiltersEnabled() ? secondaryEnabledFilters : allFilters;
      };
    },
    // Params a filter query needs to stay scoped to its parent filters.
    ppcV2FilterRelationParams(_, getters) {
      return () => {
        const {
          portfolio_id_list,
          ad_format_list,
          campaign_group_list
        } = getters.ppcV2GetFilters();
        return {
          portfolio_id_list,
          ad_format_list,
          campaign_group_list
        };
      };
    },
    ppcV2RenderedFilterKeys(state) {
      return () => Array.from(state.renderedFilterNames).map(name => state.ppcExtraFiltersToFilterKeysMap[name]);
    },
    ppcV2SecondaryFiltersEnabled(_, getters) {
      return () => {
        const {
          campaigns_list,
          keyword_id_list,
          match_type_list,
          ad_format_list,
          portfolio_id_list,
          targeting_types_list,
          campaign_group_list
        } = getters.ppcV2GetFilters();
        //console.log("campaign_group_list", campaign_group_list)
        return [campaigns_list, match_type_list, keyword_id_list, ad_format_list, portfolio_id_list, targeting_types_list, campaign_group_list].reduce((acc, curr) => acc || curr.length > 0, false);
      };
    },
    ppcV2GetAccountState(state) {
      return () => {
        const res = {
          sellers: state.sellers_filter.defaultList,
          marketplaces: state.marketplaces_filter.defaultList
        };
        return res;
      };
    },
    ppcV2GetProductTableGroupBy(state) {
      return () => state.product_table.group_by;
    },
    ppcV2GetProductTableSort(state) {
      return () => {
        let obj = {
          sort_by: [],
          sort_direction: []
        };
        for (const [key, value] of Object.entries(state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.sort)) {
          obj["sort_by"].push(key);
          obj["sort_direction"].push(value);
        }
        return obj;
      };
    },
    ppcV2GetProductTablePage(state) {
      return () => state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.page;
    },
    ppcV2GetProductTablePerPage(state) {
      return () => state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.perPage;
    },
    ppcV2GetProductTableTotalPages(state) {
      return () => state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.totalPages;
    },
    ppcV2GetProductTablePager(state) {
      return () => ({
        page: state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.page,
        page_size: state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.perPage
      });
    },
    ppcV2SecondaryFields(_, getters) {
      return () => getters.ppcV2SecondaryFiltersEnabled() ? 'TARGETING_FIELDS' : 'DEFAULT_FIELDS';
    },
    ppcV2UserOnSettingsPage(state) {
      return () => state.currentTabValue === 'settings';
    },
    ppcV2GetPeriodCategory(state) {
      return () => state.periodCategory;
    },
    ppcV2GetFirstActiveGroupBy(state) {
      const {
        group_by_elements,
        disabled_group_by_elements
      } = state.product_table;
      //console.log('[group_by_elements]', group_by_elements, disabled_group_by_elements);
      // Get the index of the first enabled group_by element
      const index = group_by_elements.findIndex(el => !disabled_group_by_elements.includes(el.key));
      //console.log('[group_by_elements]', index)
      return index;
    },
    ppcSettingsSelectedSellerAndMarketplace(state) {
      return () => ({
        seller_id: state.sellers_filter.selectedItems.slice(-1).pop()?.account_id,
        marketplace_id: state.marketplaces_filter.selectedItems.slice(-1).pop()?.marketplace_id
      });
    },
    ppcV2GetPeriodOptions(state) {
      const currentPeriod = state.period;
      return [PERIOD_OPTIONS_V2[currentPeriod].LEFT, PERIOD_OPTIONS_V2[currentPeriod].RIGHT];
    }
  },
  actions: {
    ppcV2SetTab({
      commit
    }, tab) {
      commit("ppcV2SetTab", tab);
    },
    ppcV2SetPeriod({
      commit
    }, period) {
      commit("ppcV2SetPeriod", period);
    },
    async ppcV2FetchKpis({
      commit,
      getters,
      state
    }) {
      try {
        const params = {
          period: state.period,
          ...getters.ppcV2UnifiedFilters(),
          ...getters.currencyConfigQueryGet(),
          ...getters.dateConfigQueryGet()
        };
        let response = await request("/ppc/v2/current_period/kpis", "POST", params, false, true, "cors");
        if (response) {
          let data = response.data;
          data = data.kpis.pop();
          createCurrentPeriodViewFromData(data, state.kpis_v2.considered_kpis);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async ppcV2FetchPeriodTableData({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        const {
          store = true
        } = options;
        const params = {
          period: state.period,
          ...getters.ppcV2UnifiedFilters(),
          ...getters.currencyConfigQueryGet(),
          ...getters.dateConfigQueryGet(),
          period_page: state.periodTable.period_page
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request("/ppc/v2/global/evolution", "POST", params, false, true, "cors");
        if (!response) {
          return [];
        }
        let data = response.data.graph;

        // Compute and store the minMax object
        if (data && store) {
          commit("ppcV2SetPeriodTableItems", data);
          commit("ppcV2SetPeriodTableMaxCharCount", {
            currency: computeCurrencyMaxCharCount(data, full, currency, precision, showCurrencySign, false, limit),
            number: computeNumberMaxCharCount(data),
            percentage: computePercentageMaxCharCount(data)
          });
          commit("ppcV2SetPeriodTableMinMax", computeMinMax(data, ["period_agg"]));
        }
        return response;
      } catch (err) {
        commit('ppcV2SetPeriodTableErrorState', true);
      }
    },
    ppcV2SetProductTableGroupByElements({
      commit,
      getters
    }) {
      const {
        sellers,
        marketplaces
      } = getters.ppcV2GetAccountState();
      const {
        CAMPAIGN_GROUP,
        CAMPAIGN,
        TARGETING,
        SELLER,
        MARKETPLACE,
        AD_FORMAT
      } = GROUP_BY_TAB_ELEMENTS;
      const defaultElements = [AD_FORMAT, CAMPAIGN_GROUP, CAMPAIGN, TARGETING];
      if (sellers.length > 1 && marketplaces.length > 1) {
        commit("ppcV2SetProductTableGroupByElements", [SELLER, MARKETPLACE, ...defaultElements]);
        const activeTab = getters.ppcV2GetFirstActiveGroupBy;
        commit("ppcV2SetProductTableGroupBy", activeTab);
        return;
      } else if (marketplaces.length > 1) {
        commit("ppcV2SetProductTableGroupByElements", [MARKETPLACE, ...defaultElements]);
        const activeTab = getters.ppcV2GetFirstActiveGroupBy;
        commit("ppcV2SetProductTableGroupBy", activeTab);
        return;
      }
      commit("ppcV2SetProductTableGroupByElements", defaultElements);
      const activeTab = getters.ppcV2GetFirstActiveGroupBy;
      commit("ppcV2SetProductTableGroupBy", activeTab);
    },
    ppcV2SetSecondaryFiltersProductTableGroupByElements({
      commit
    }) {
      const {
        SELLER,
        MARKETPLACE
      } = GROUP_BY_TAB_ELEMENTS;
      commit("ppcV2DeactivateGroupBy", [SELLER, MARKETPLACE].map(({
        key
      }) => key));
    },
    ppcV2SetProductTableState({
      commit
    }, payload) {
      commit("ppcV2SetProductTableState", payload);
    },
    ppcV2SetProductTablePeriod({
      commit
    }, period) {
      commit("ppcV2SetProductTablePeriod", period);
    },
    ppcV2SetProductTableGroupBy({
      commit
    }, groupBy) {
      commit("ppcV2SetProductTableGroupBy", groupBy);
    },
    async ppcV2FetchReportGroupedBySellers({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.ppcV2GetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...pager,
          ...getters.ppcV2UnifiedFilters(),
          ...getters.ppcV2GetProductTableSort(),
          ...getters.currencyConfigQueryGet()
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request("/ppc/v2/report/sellers", "POST", params, false, true, "cors");
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          const {
            result
          } = report;
          if (store) {
            commit("ppcV2SetProductTableTotalPages", total?.[0]?.row_count ?? 0);
            commit("ppcV2SetProductTableItems", result);
            commit("ppcV2SetProductTableMaxCharCount", {
              currency: computeCurrencyMaxCharCount(result, full, currency, precision, showCurrencySign, false, limit),
              number: computeNumberMaxCharCount(result),
              percentage: computePercentageMaxCharCount(result)
            });
            commit("ppcV2SetProductTableTotal", total?.pop() ?? {});
            commit("ppcV2SetProductTableMinMax", computeMinMax(result));
          }
        }
        return response;
      } catch (error) {
        commit('ppcV2SetProductTableErrorState', true);
      }
    },
    async ppcV2FetchReportGroupedByMarketplaces({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.ppcV2GetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.ppcV2UnifiedFilters(),
          ...getters.ppcV2GetProductTableSort(),
          ...pager,
          ...getters.currencyConfigQueryGet()
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request("/ppc/v2/report/marketplace", "POST", params, false, true, "cors");
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          let {
            result
          } = report;
          result = await transformWithCountries(result);
          if (store) {
            commit("ppcV2SetProductTableTotalPages", total?.[0]?.row_count ?? 0);
            commit("ppcV2SetProductTableItems", result);
            commit("ppcV2SetProductTableMaxCharCount", {
              currency: computeCurrencyMaxCharCount(result, full, currency, precision, showCurrencySign, false, limit),
              number: computeNumberMaxCharCount(result),
              percentage: computePercentageMaxCharCount(result)
            });
            commit("ppcV2SetProductTableTotal", total?.pop() ?? {});
            commit("ppcV2SetProductTableMinMax", computeMinMax(result));
          }
        }
        return response;
      } catch (error) {
        commit('ppcV2SetProductTableErrorState', true);
      }
    },
    async ppcV2FetchReportGroupedByProducts({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.ppcV2GetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.ppcV2UnifiedFilters(),
          ...getters.ppcV2GetProductTableSort(),
          ...pager,
          ...getters.currencyConfigQueryGet()
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request("/ppc/v2/report/product", "POST", params, false, true, "cors");
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          const {
            result
          } = report;
          if (store) {
            commit("ppcV2SetProductTableTotalPages", total?.[0]?.row_count ?? 0);
            commit("ppcV2SetProductTableItems", result);
            commit("ppcV2SetProductTableMaxCharCount", {
              currency: computeCurrencyMaxCharCount(result, full, currency, precision, showCurrencySign, false, limit),
              number: computeNumberMaxCharCount(result),
              percentage: computePercentageMaxCharCount(result)
            });
            commit("ppcV2SetProductTableTotal", total?.pop() ?? {});
            commit("ppcV2SetProductTableMinMax", computeMinMax(result));
          }
        }
        return response;
      } catch (error) {
        commit('ppcV2SetProductTableErrorState', true);
      }
    },
    async ppcV2FetchReportGroupedByCampaignGroups({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.ppcV2GetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.ppcV2UnifiedFilters(),
          ...getters.ppcV2GetProductTableSort(),
          ...pager,
          ...getters.currencyConfigQueryGet()
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request("/ppc/v2/report/product_group", "POST", params, false, true, "cors");
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          let {
            result
          } = report;
          result = await transformWithCountries(result);
          if (store) {
            commit("ppcV2SetProductTableTotalPages", total?.[0]?.row_count ?? 0);
            commit("ppcV2SetProductTableItems", result);
            commit("ppcV2SetProductTableMaxCharCount", {
              currency: computeCurrencyMaxCharCount(result, full, currency, precision, showCurrencySign, false, limit),
              number: computeNumberMaxCharCount(result),
              percentage: computePercentageMaxCharCount(result)
            });
            commit("ppcV2SetProductTableTotal", total?.pop() ?? {});
            commit("ppcV2SetProductTableMinMax", computeMinMax(result));
          }
        }
        return response;
      } catch (error) {
        commit('ppcV2SetProductTableErrorState', true);
      }
    },
    async ppcV2FetchReportGroupedByCampaigns({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.ppcV2GetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.ppcV2UnifiedFilters(),
          ...getters.ppcV2GetProductTableSort(),
          ...pager,
          ...getters.currencyConfigQueryGet()
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request("/ppc/v2/report/campaign", "POST", params, false, true, "cors");
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          let {
            result
          } = report;
          result = await transformWithCountries(result);
          if (store) {
            commit("ppcV2SetProductTableTotalPages", total?.[0]?.row_count ?? 0);
            commit("ppcV2SetProductTableItems", result);
            commit("ppcV2SetProductTableMaxCharCount", {
              currency: computeCurrencyMaxCharCount(result, full, currency, precision, showCurrencySign, false, limit),
              number: computeNumberMaxCharCount(result),
              percentage: computePercentageMaxCharCount(result)
            });
            commit("ppcV2SetProductTableTotal", total?.pop() ?? {});
            commit("ppcV2SetProductTableMinMax", computeMinMax(result));
          }
        }
        return response;
      } catch (error) {
        commit('ppcV2SetProductTableErrorState', true);
      }
    },
    async ppcV2FetchReportGroupedByTargetings({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.ppcV2GetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.ppcV2UnifiedFilters(),
          ...getters.ppcV2GetProductTableSort(),
          ...pager,
          ...getters.currencyConfigQueryGet()
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request("/ppc/v2/report/targeting", "POST", params, false, true, "cors");
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          const {
            result
          } = report;
          if (store) {
            commit("ppcV2SetProductTableTotalPages", total?.[0]?.row_count ?? 0);
            commit("ppcV2SetProductTableItems", result);
            commit("ppcV2SetProductTableMaxCharCount", {
              currency: computeCurrencyMaxCharCount(result, full, currency, precision, showCurrencySign, false, limit),
              number: computeNumberMaxCharCount(result),
              percentage: computePercentageMaxCharCount(result)
            });
            commit("ppcV2SetProductTableTotal", total?.pop() ?? {});
            commit("ppcV2SetProductTableMinMax", computeMinMax(result));
          }
        }
        return response;
      } catch (error) {
        commit('ppcV2SetProductTableErrorState', true);
      }
    },
    async ppcV2FetchReportGroupedByAdFormats({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.ppcV2GetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.ppcV2UnifiedFilters(),
          ...getters.ppcV2GetProductTableSort(),
          ...pager,
          ...getters.currencyConfigQueryGet()
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request("/ppc/v2/report/ad_format", "POST", params, false, true, "cors");
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          const {
            result
          } = report;
          if (store) {
            commit("ppcV2SetProductTableTotalPages", total?.[0]?.row_count ?? 0);
            commit("ppcV2SetProductTableItems", result);
            commit("ppcV2SetProductTableMaxCharCount", {
              currency: computeCurrencyMaxCharCount(result, full, currency, precision, showCurrencySign, false, limit),
              number: computeNumberMaxCharCount(result),
              percentage: computePercentageMaxCharCount(result)
            });
            commit("ppcV2SetProductTableTotal", total?.pop() ?? {});
            commit("ppcV2SetProductTableMinMax", computeMinMax(result));
          }
        }
        return response;
      } catch (error) {
        commit('ppcV2SetProductTableErrorState', true);
      }
    },
    ppcV2SetProductTablePage({
      commit
    }, page) {
      commit("ppcV2SetProductTablePage", page);
    },
    ppcV2SetProductTablePerPage({
      commit
    }, perPage) {
      commit("ppcV2SetProductTablePerPage", perPage);
    },
    ppcV2SetProductTableSort({
      commit
    }, payload) {
      commit("ppcV2SetProductTableSort", payload);
    },
    ppcV2SetProductTableTotalPages({
      commit
    }, payload) {
      commit("ppcV2SetProductTableTotalPages", payload);
    },
    ppcV2SetPeriodTableErrorState({
      commit
    }, payload) {
      commit('ppcV2SetPeriodTableErrorState', payload);
    },
    ppcV2SetProductTableErrorState({
      commit
    }, payload) {
      commit('ppcV2SetProductTableErrorState', payload);
    },
    ppcV2SetDefaultCurrency({
      getters,
      commit
    }) {
      commit('ppcV2DefaultCurrencySet', getters.currencyConfigQueryGet().currency);
    },
    ppcV2CleanDisabledGroupBy({
      commit
    }) {
      commit('ppcV2CleanDisabledGroupBy');
    },
    ppcV2SetPeriodCategory({
      commit
    }, periodCategory) {
      commit('ppcV2SetPeriodCategory', periodCategory);
    },
    ppcV2IncrementPeriodPage({
      commit
    }) {
      commit('ppcV2IncrementPeriodPage');
    },
    ppcV2SetFilterManager({
      commit
    }, filterManager) {
      commit('ppcV2SetFilterManager', filterManager);
    },
    ppcV2AddFilter({
      commit
    }, payload) {
      commit('ppcV2AddFilter', payload);
    }
  }
};